import * as Avatar from '@givebutter/primitives/avatar';
import { faCloudUpload } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { ThemeProvider } from 'providers/ThemeProvider';
import { twMerge } from 'tailwind-merge';

interface UploadLabelProps {
    label?: string;
    className?: string;
}

const UploadLabel = (props: UploadLabelProps) => {
    const { label = 'Click to add photos', className } = props;

    return (
        <ThemeProvider>
            <div
                className={twMerge(
                    'flex flex-col items-center justify-center gap-1 md:gap-4',
                    className,
                )}
            >
                <Avatar.Root>
                    <Avatar.Fallback aria-label="Upload icon">
                        <FontAwesomeIcon className={'!text-2xl'} icon={faCloudUpload} />
                    </Avatar.Fallback>
                </Avatar.Root>
                <p className={'!text-xs !font-medium text-blue-500 underline md:!text-base'}>
                    {label}
                </p>
                <p className={'!text-xs text-gray-600 md:!text-base'}>or drag and drop</p>
            </div>
        </ThemeProvider>
    );
};

export { UploadLabel };
